let socket = null;

export const WebSocketManager = {
  connect: ({ onConnected, onDisconnected, onMessage, onError, endpoint }) => {
    const params = new URLSearchParams(window.location.search);
    const pin = params.get("pin");
    const uuid = params.get("uuid");
    const username = params.get("username");

    if (!pin || !uuid) {
      alert("Missing URL parameters: pin or uuid");
      return;
    }

    let wsUrl = `${endpoint}?pin=${encodeURIComponent(pin)}&uuid=${encodeURIComponent(uuid)}`;
    if (username) {
      wsUrl += `&username=${encodeURIComponent(username)}`;
    }

    socket = new WebSocket(wsUrl);

    socket.addEventListener("open", () => {});

    socket.addEventListener("message", (event) => {
      try {
        const data = JSON.parse(event.data);

        if (data.ACTION === "CONNECTION_STATE") {
          if (data["state-text"] === "Connected") {
            onConnected?.(uuid, username);
          } else if (
            data["state-code"] === 431 &&
            data["state-text"] === "Invalid Access"
          ) {
            alert("Invalid Access");
            socket.close();
          }
        } else {
          onMessage?.(data);
        }
      } catch (err) {
        console.warn("Invalid message:", event.data);
      }
    });

    socket.addEventListener("close", () => {
      console.log("Connection closed");
      onDisconnected?.();
    });

    socket.addEventListener("error", () => {
      console.log("WebSocket connection error");
      onError?.();
    });
  },

  send: (msg) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(JSON.stringify(msg));
    }
  },

  disconnect: () => {
    if (socket) {
      socket.close();
      socket = null;
    }
  },
};
